module.exports = __webpack_public_path__ + "static/img/reason_1.223ed050.png";